class FileUploadController {
  /* @ngInject */
  constructor($scope) {
    this.$scope = $scope;
  }

  $onInit() {
    this.modelTmp = this.model;
    this.$scope.$watch(() => this.model, (newVal) => {
      this.modelTmp = newVal;
    }, true);
    this.multiple = this.multiple || this.multiple === 'true';
  }

  addFiles() {
    this.model = (this.model || []).concat(...this.modelTmp);
  }
}

export default FileUploadController;



// WEBPACK FOOTER //
// ./client/components/file-upload/file-upload.controller.js